import {
  LocationType,
  type MappedCountry,
  type MappedCity,
} from '../../shared/types';

const COUNTRIES: Record<string, MappedCountry> = {
  KZ: {
    code: 'KZ',
    name: 'Казахстан',
    name_en: 'Kazakhstan',
    name_kk: 'Қазақстан',
    name_ru: 'Казахстан',
    type: LocationType.COUNTRY,
  },
  RU: {
    code: 'RU',
    name: 'Россия',
    name_en: 'Russia',
    name_kk: 'Ресей',
    name_ru: 'Россия',
    type: LocationType.COUNTRY,
  },
  TR: {
    code: 'TR',
    name: 'Турция',
    name_en: 'Turkey',
    name_kk: 'Түркия',
    name_ru: 'Турция',
    type: LocationType.COUNTRY,
  },
};

const POPULAR_DEPARTURES: Array<MappedCity> = [
  {
    code: 'ALA',
    name: 'Алматы',
    name_en: 'Almaty',
    name_kk: 'Алматы',
    name_ru: 'Алматы',
    type: LocationType.CITY,
    country: COUNTRIES.KZ,
  },
  {
    code: 'NQZ',
    name: 'Астана',
    name_en: 'Astana',
    name_kk: 'Астана',
    name_ru: 'Астана',
    type: LocationType.CITY,
    country: COUNTRIES.KZ,
  },
  {
    code: 'CIT',
    name: 'Шымкент',
    name_en: 'Shymkent',
    name_kk: 'Шымкент',
    name_ru: 'Шымкент',
    type: LocationType.CITY,
    country: COUNTRIES.KZ,
  },
  {
    code: 'SCO',
    name: 'Актау',
    name_en: 'Aktau',
    name_kk: 'Ақтау',
    name_ru: 'Актау',
    type: LocationType.CITY,
    country: COUNTRIES.KZ,
  },
  {
    code: 'GUW',
    name: 'Атырау',
    name_en: 'Atyrau',
    name_kk: 'Атырау',
    name_ru: 'Атырау',
    type: LocationType.CITY,
    country: COUNTRIES.KZ,
  },
  {
    code: 'PWQ',
    name: 'Павлодар',
    name_en: 'Pavlodar',
    name_kk: 'Павлодар',
    name_ru: 'Павлодар',
    type: LocationType.CITY,
    country: COUNTRIES.KZ,
  },
];

const POPULAR_ARRIVALS: Array<MappedCity> = [
  {
    code: 'NQZ',
    name: 'Астана',
    name_en: 'Astana',
    name_kk: 'Астана',
    name_ru: 'Астана',
    type: LocationType.CITY,
    country: COUNTRIES.KZ,
  },
  {
    code: 'ALA',
    name: 'Алматы',
    name_en: 'Almaty',
    name_kk: 'Алматы',
    name_ru: 'Алматы',
    type: LocationType.CITY,
    country: COUNTRIES.KZ,
  },
  {
    code: 'MOW',
    name: 'Москва',
    name_en: 'Moscow',
    name_kk: 'Мәскеу',
    name_ru: 'Москва',
    type: LocationType.CITY,
    country: COUNTRIES.RU,
  },
  {
    code: 'IST',
    name: 'Стамбул',
    name_en: 'Istanbul',
    name_kk: 'Ыстамбұл',
    name_ru: 'Стамбул',
    type: LocationType.CITY,
    country: COUNTRIES.TR,
  },
  {
    code: 'CIT',
    name: 'Шымкент',
    name_en: 'Shymkent',
    name_kk: 'Шымкент',
    name_ru: 'Шымкент',
    type: LocationType.CITY,
    country: COUNTRIES.KZ,
  },
  {
    code: 'SCO',
    name: 'Актау',
    name_en: 'Aktau',
    name_kk: 'Ақтау',
    name_ru: 'Актау',
    type: LocationType.CITY,
    country: COUNTRIES.KZ,
  },
];

export const searchCitiesConfig = {
  POPULAR_ARRIVALS,
  POPULAR_DEPARTURES,
  COUNTRIES,
};
